import { i18n_t as $t } from '@/utils/i18n';

export const segmentDeletedTitle = () => $t('segmentDeletedError.Segment not found.');

export const segmentDeletedSubtext = () =>
    $t('segmentDeletedError.It may have been deleted or you no longer have access. Select a different segment to continue.');

export const segmentDeletedOverlayOptions = () => ({
    errorText: segmentDeletedTitle(),
    errorSubtext: segmentDeletedSubtext(),
});

export const isSelectedSegmentDeleted = ({ selectedSegmentId, segmentById }) => {
    if (!selectedSegmentId) return false;

    return !segmentById(selectedSegmentId);
};
